export const RedCross = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4 18H10.6C10.2686 18 10 17.7314 10 17.4V15.1C10 14.7686 9.73137 14.5 9.4 14.5H7.1C6.76863 14.5 6.5 14.2314 6.5 13.9V10.1C6.5 9.76863 6.76863 9.5 7.1 9.5H9.4C9.73137 9.5 10 9.23137 10 8.9V6.6C10 6.26863 10.2686 6 10.6 6H14.4C14.7314 6 15 6.26863 15 6.6V8.9C15 9.23137 15.2686 9.5 15.6 9.5H17.9C18.2314 9.5 18.5 9.76863 18.5 10.1V13.9C18.5 14.2314 18.2314 14.5 17.9 14.5H15.6C15.2686 14.5 15 14.7686 15 15.1V17.4C15 17.7314 14.7314 18 14.4 18Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
